<template>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col mt-4 mb-4 card-accont col-lg-8">
        <div class="row mb-2">
          <div class="col-lg-12 text-center card-accont-title">Datos de cuenta</div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <label>
              <b>
                <font-awesome-icon :icon="['fal', 'user-circle']" />
              </b> Nombre:
            </label>
            {{ userName }}
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <label>
              <b>
                <font-awesome-icon :icon="['fal', 'envelope']" />
              </b> Correo electrónico:
            </label>
            {{ EmailMail }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    userName () {
      return `${this.user.name} ${this.user.last_name_1} ${this.user.last_name_2}`
    },
    EmailMail () {
      return `${this.user.email}`
    }
  }
}
</script>
